import React, { Component } from 'react'
import Card, { CardBackground } from './Card'
import Icon, { IconColor } from './Icon'
import Tooltip from './Tooltip/Tooltip'
import { i18n } from "../i18n/i18n";

type CountCardType = CardBackground
type CountCards = Record<CountCardType, CountCardItem>

export interface CountData {
  primary?: string
  secondary?: string
  tooltip?: string
}

interface CountCardItem {
  background: CountCardType
  flat: boolean
  color: string
  iconColor: IconColor
}

interface CountCardProps {
  type: CountCardType
  icon: string
  heading: string
  counts?: CountData[]
}

export default class CountCard extends Component<CountCardProps> {
  countCards: CountCards = {
    white: {
      background: 'white',
      flat: false,
      color: 'text-primary',
      iconColor: 'dark'
    },
    primary: {
      background: 'primary',
      flat: true,
      color: 'text-white',
      iconColor: 'white'
    },
    secondary: {
      background: 'secondary',
      flat: true,
      color: 'text-primary',
      iconColor: 'dark'
    }
  }

  get countCard () {
    return this.countCards[this.props.type]
  }

  get className () {
    const base = 'flex flex-col justify-end'
    return `${base} ${this.countCard.color}`
  }

  count (count: CountData, index: number) {
    const { primary, secondary, tooltip } = count
    return (
      <div key={index} className="text-xs">
        <span className="font-medium mr-1">{primary}</span>
        <Tooltip text={tooltip || ''}>
          <span className="text-secondary">{secondary}</span>
        </Tooltip>
      </div>
    )
  }

  get counts () {
    const { counts } = this.props
    if (counts) {
      return (
        <div className='flex flex-col'>
          {counts.map((count, index) => this.count(count, index))}
        </div>
      )
    }
  }

  render () {
    return (
      <Card
        className={this.className}
        background={this.countCard.background}
        flat={this.countCard.flat}>
        <div>
          <div className="flex justify-between mb-2 gap-1 items-end">
            <Icon
              name={this.props.icon}
              size="large"
              color={this.countCard.iconColor} />
            {this.counts}
          </div>
          <div>{this.props.heading}</div>
        </div>
      </Card>
    )
  }
}
